// Service worker registration and update detection.
//
// The update path matters more than the install path. Once a service worker is
// on a customer's phone it will happily serve the old bundle until something
// tells it not to — and this site changes several times a week. So: register,
// watch for a waiting worker, and give the page a way to say "there is a new
// version" rather than leaving people on last week's app.

let waitingWorker = null;
const listeners = new Set();

function notify(state) {
  listeners.forEach((fn) => { try { fn(state); } catch (e) { /* a broken listener must not break the app */ } });
}

export function onUpdateAvailable(fn) {
  listeners.add(fn);
  if (waitingWorker) fn(true);
  return () => listeners.delete(fn);
}

export function applyUpdate() {
  if (!waitingWorker) { window.location.reload(); return; }
  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  // The new worker takes over, then we reload once into it.
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        if (reg.waiting) { waitingWorker = reg.waiting; notify(true); }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // "installed" with an existing controller means a NEW version is
            // ready behind the one currently running.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              waitingWorker = installing;
              notify(true);
            }
          });
        });
        // Catch a version published while the app sits open on someone's desk.
        setInterval(() => { reg.update().catch(() => undefined); }, 60 * 60 * 1000);
      })
      .catch(() => { /* no service worker is a degraded app, not a broken one */ });
  });
}

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}
